import React, { Component } from 'react';
import { Table, Modal, Input, Button } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';

class PreviewModal extends Component {
    state = {
        data: [],
        type: '',
        record: {},
        loading: false,
        visible: false,
        pagination: {},
        sortParams: {},
    }

    show = (type, record) => {
        this.setState({
            type,
            record,
            visible: true,
            sortParams: {},
            pagination: {
                current: 1,
                pageSize: 5,
            },
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { type, pagination, record: { userId } } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryTalentsInfoList,
            data: {
                type,
                userId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        }
    }

    getColumns = () => {
        const { type } = this.state;
        const columns = [];
        if (type == 'PM') {
            columns.push({
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
            }, {
                title: '担任PM的项目',
                dataIndex: 'investigationName',
                key: 'investigationName',
            }, {
                title: '担任PM时间',
                dataIndex: 'date',
                key: 'date',
                render: (text, record) => {
                    const { beginTime, endTime } = record;
                    // return beginTime ? `${beginTime.slice(0, 10)}` : '';
                    return `${beginTime.slice(0, 10)}~${endTime ? endTime.slice(0, 10) : '至今'}`;
                }
            });
        } else if (type == 'PA') {
            columns.push({
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
            }, {
                title: '担任PA的项目',
                dataIndex: 'investigationName',
                key: 'investigationName',
            }, {
                title: '担任PA时间',
                dataIndex: 'userMobile',
                key: 'userMobile',
                render: (text, record) => {
                    const { beginTime, endTime } = record;
                    // return beginTime ? `${beginTime.slice(0, 10)}` : '';
                    return `${beginTime.slice(0, 10)}~${endTime ? endTime.slice(0, 10) : '至今'}`;
                }
            });
        } else if (type == 'JOB') {
            columns.push({
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
            }, {
                title: '转岗时间',
                dataIndex: 'promotionTime',
                key: 'promotionTime',
                render: this.getRender('date'),
            }, {
                title: '转岗前职位',
                dataIndex: 'beforePositionName',
                key: 'beforePositionName',
            }, {
                title: '转岗后职位',
                dataIndex: 'afterPositionName',
                key: 'afterPositionName',
            }, {
                title: '转岗后部门',
                dataIndex: 'afterDepartmentName',
                key: 'afterDepartmentName',
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { type, loading, visible, pagination, record: { userCompellation, employeeCode } } = this.state;
        let title;
        let modalWidth = 800;
        if (type == 'PM') {
            title = '旗下人员在项目上担任PM数量';
        } else if (type == 'PA') {
            title = '旗下人员在项目上担任PA数量';
        } else if (type == 'JOB') {
            title = '旗下临床协调员异动转岗数量(加分项)';
        }
        return (
            <Modal
                title={title}
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width={modalWidth}
                maskClosable={false}
                footer={<Button type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{marginBottom: 15}}>
                        人员主管：{`${userCompellation}[${employeeCode}]`}
                    </div>
                    <div>
                        <Table
                            bordered
                            loading={loading}
                            scroll={{x: 550}}
                            pagination={pagination}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={row => row.index}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

class Filter extends Component {
    state = {
        searchParams: {}
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({...searchParams});
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    render() {
        const { searchParams: { employeeCode, userCompellation } } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label className="ui-label">人员主管工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">人员主管姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onKeyPress={this.handleKeyPress}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Talent extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryTalentsList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = searchParams => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, sortParams, searchParams } = this.state;
        ExportUtil.export({ ...sortParams, ...searchParams }, pagination, API_URL.user.exportTalentsList);
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '人员主管工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
        }, {
            title: '人员主管姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '旗下人员在项目上担任PM数量',
            dataIndex: 'pmCount',
            key: 'pmCount',
            render: (text, record) => {
                return <a onClick={() => this.showPreviewModal('PM', record)}>{text}</a>;
            }
        }, {
            title: '旗下人员在项目上担任PA数量',
            dataIndex: 'paCount',
            key: 'paCount',
            render: (text, record) => {
                return <a onClick={() => this.showPreviewModal('PA', record)}>{text}</a>;
            }
        }, {
            title: '旗下临床协调员异动转岗数量(加分项)',
            dataIndex: 'jobCount',
            key: 'jobCount',
            render: (text, record) => {
                return <a onClick={() => this.showPreviewModal('JOB', record)}>{text}</a>;
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    showPreviewModal = (type, record) => {
        this.previewModalRef.show(type, {...record});
    }

    render() {
        const { loading, pagination } = this.state;
        return (
            <div>
                <Filter search={this.search} export={this.export} />
                <Table
                    bordered
                    loading={loading}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={row => row.index}
                    onChange={this.handleTableChange}
                />
                <PreviewModal ref={el => this.previewModalRef = el} />
            </div>
        );
    }
}

export default Talent;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/Talent.js